import i18n from '@/i18n'

export const printFile = (fileData?: File) => {
  if (!fileData) return
  const fileBlob = new Blob([fileData], { type: 'application/pdf' })
  const fileURL = window.URL.createObjectURL(fileBlob)
  const printWindow = window.open(fileURL)

  if (printWindow) {
    printWindow.onload = () => {
      printWindow.focus()
      printWindow.print()
    }
  } else {
    alert(i18n.t('help.failed-to-open-print-window', { ns: 'common' }))
  }
}
